export const PaymentTypes = {
    CORPORATE: 'corporate',
    FRANCHISE: 'franchise',
    BUSINESS: 'business',
    PASSTHROUGH_ENTITY: 'passthrough_entity',
    ANNUAL: 'annual',
    QUARTERLY: 'quarterly',
    EXTENSION: 'extension',
    OTHER: 'other',
};

export const Payer = {
    INDIVIDUAL: 'individual',
    LLC: 'llc',
    SCORP: 'scorp',
};

export const RoleScope = {
    MEMBER: 'member',
    MEMBER_SERVICE: 'member_service',
};

/**
 * A payment's `payee` carries its jurisdiction: this value means federal, and any
 * other value is a two-letter state code. There is no separate tax-type field, so
 * every federal/state split keys off this comparison.
 */
export const FEDERAL_PAYEE = 'US';
